/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AllImageSeries/view.blocks to change it.
import * as fromHelpers from './helpers.js'
import ArrowRight from 'DesignSystem/Svgs/ArrowRight/index'
import ButtonBreadcrumbUnder from 'DesignSystem/ButtonBreadcrumbUnder/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function AllImageSeries({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/MessageTools/External/Tools/AttachmentAction/InApp/Documents/Content/Patients/Content/Breadcrumb/ImageSeries/AllImageSeries"
  
}) {
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<div
  data-testid="AllImageSeries.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<ArrowRight
  viewPath={`${viewPath}/ArrowRight`}
 width={14}
 height={14}
 marginLeft={16}
 marginRight={16}
 stroke="rgba(0,0,0,0.3)"
/>
<ButtonBreadcrumbUnder
  viewPath={`${viewPath}/ButtonBreadcrumbUnder`}
 onClick={onClick}
 text="All image series"
/>
</div>
{children}
</React.Fragment>)
}